/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ServiceAccountNativeDetailsBaseForCostCenterCloud extends models.ServiceAccountNativeDetailsBaseForCostCenter {
    constructor() {
        super();
        this.setDiscriminator("ServiceAccountNativeDetailsBaseForCostCenterCloud");
    }

    getFixupPrototypeFunction() { return ServiceAccountNativeDetailsBaseForCostCenterCloud.fixupPrototype; }

    static newInstance(model: Partial<ServiceAccountNativeDetailsBaseForCostCenterCloud>): ServiceAccountNativeDetailsBaseForCostCenterCloud {
        let obj = Object.assign(new ServiceAccountNativeDetailsBaseForCostCenterCloud(), model);
        ServiceAccountNativeDetailsBaseForCostCenterCloud.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ServiceAccountNativeDetailsBaseForCostCenterCloud>): ServiceAccountNativeDetailsBaseForCostCenterCloud {
        if (!model) return null;
        return ServiceAccountNativeDetailsBaseForCostCenterCloud.newInstance(<ServiceAccountNativeDetailsBaseForCostCenterCloud> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ServiceAccountNativeDetailsBaseForCostCenterCloud) {
        if (!obj) return;

        models.ServiceAccountNativeDetailsBaseForCostCenterCloud.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ServiceAccountNativeDetailsBaseForCostCenterCloud): boolean {
        if (models.ServiceAccountNativeDetailsBaseForCostCenter.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ServiceAccountNativeDetailsBaseForCostCenterCloud.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
